<template>
  <b-modal
    ref="archiveAddModal"
    v-testing="'wrapper'"
    size="xl"
    :title="$t('archive.modal.archiving')"
    centered
    modal-class="add-modal"
    hide-footer
    qa="archive-add-modal"
    @hide="onHide"
  >
    <archive-location-sidepanel
      v-if="sidePanel"
      @closeArchiveLocationSidepanel="closeArchiveLocationSidepanel"
    />
    <div
      v-if="showWizard"
      class="h-100 d-flex align-items-center justify-content-center archive-wizard"
    >
      <div class="d-flex flex-column align-items-center">
        <div class="icon mb-5">
          <archive class="eyyy" />
        </div>
        <span class="home secondary-color">
          {{ $t('archive.modal.wizardQuestion') }}
        </span>
        <div class="mt-5">
          <b-row>
            <b-col
              qa="archive-samples-button"
              class="d-flex flex-column align-items-center"
              @click="archiveSample"
            >
              <div class="wizard-button home">
                <i
                  class="fal fa-prescription-bottle"
                  aria-hidden="true"
                />
              </div>
              <p class="ap-title ap-title__section text-center">
                {{ $tc('global.sample', 2) }}
              </p>
            </b-col>
            <b-col
              qa="archive-paraffin-blocks-button"
              class="d-flex flex-column align-items-center"
              @click="archiveParaffinBlock"
            >
              <div class="wizard-button home">
                <i
                  class="icon-block"
                  aria-hidden="true"
                />
              </div>
              <p class="ap-title ap-title__section text-center">
                {{ $t('archive.sidebar.paraffinBlocks') }}
              </p>
            </b-col>
            <b-col
              qa="archive-frozen-blocks-button"
              class="d-flex flex-column align-items-center"
              @click="archiveFrozenBlock"
            >
              <div class="wizard-button home">
                <i
                  class="icon-frozen-block"
                  aria-hidden="true"
                />
              </div>
              <p class="ap-title ap-title__section text-center">
                {{ $t('archive.sidebar.frozenBlocks') }}
              </p>
            </b-col>
            <b-col
              qa="archive-slides-button"
              class="d-flex flex-column align-items-center"
              @click="archiveSlide"
            >
              <div class="wizard-button home">
                <i
                  class="icon-porta"
                  aria-hidden="true"
                />
              </div>
              <p class="ap-title ap-title__section text-center">
                {{ $t('archive.sidebar.slides') }}
              </p>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div
      v-if="!showWizard"
      class="h-100 d-flex flex-column justify-content-between"
    >
      <div>
        <b-row class="pl-2">
          <b-col>
            <div class="making-zone px-2 d-flex justify-content-between">
              <div class="my-2">
                <div class="d-flex align-items-center">
                  <div>
                    <span class="ap-title ap-title__main">
                      <i
                        :class="elementIcon"
                        class="mr-2"
                        aria-hidden="true"
                      />
                      {{ $t(title) }}
                    </span>
                  </div>
                  <span class="ap-title ap-title__section ml-3">({{ $tc('archive.modal.elementCount', elements.length, { n: elements.length }) | lowercase }})</span>
                </div>
              </div>
              <div
                v-if="pendingToArchive"
                class="d-flex align-items-center"
              >
                <span class="add-label label-dark mr-3">{{ $t('archive.modal.addElements') }}:</span>
                <searcher-module
                  ref="searcherModule"
                  class="mx-3"
                  :error-message="searcherValidationErrorMessage"
                  name="archiveSearcher"
                  :is-general-disabled="true"
                  :restore-search-state="false"
                  :default-search-type="'currentPage'"
                  :sample-search="internalEntityType === COREENTITY_VALUES.SAMPLE"
                  :portion-search="internalEntityType === COREENTITY_VALUES.PORTION"
                  :subportion-search="internalEntityType === COREENTITY_VALUES.SUBPORTION"
                  @sampleSearch="onEntitySearch($event, COREENTITY_VALUES.SAMPLE)"
                  @portionSearch="onEntitySearch($event, COREENTITY_VALUES.PORTION)"
                  @subportionSearch="onEntitySearch($event, COREENTITY_VALUES.SUBPORTION)"
                />
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- TODO Front: the following row is prepared for the new development, see UX document for details -->
        <b-row
          v-if="false"
          class="px-3 py-2 mb-3"
        >
          <b-col>
            <div class="form-label">
              <label>{{ $tc('archive.modal.addElements') }}</label>
            </div>
            <searcher-module
              ref="searcherModule"
              :error-message="searcherValidationErrorMessage"
              name="archiveSearcher"
              :is-general-disabled="true"
              :restore-search-state="false"
              :default-search-type="'currentPage'"
              :sample-search="internalEntityType === COREENTITY_VALUES.SAMPLE"
              :portion-search="internalEntityType === COREENTITY_VALUES.PORTION"
              :subportion-search="internalEntityType === COREENTITY_VALUES.SUBPORTION"
              @sampleSearch="onEntitySearch($event, COREENTITY_VALUES.SAMPLE)"
              @portionSearch="onEntitySearch($event, COREENTITY_VALUES.PORTION)"
              @subportionSearch="onEntitySearch($event, COREENTITY_VALUES.SUBPORTION)"
            />
          </b-col>
          <b-col>
            <div class="form-label">
              <label>{{ $tc('archive.modal.where') }}</label>
            </div>
            <div class="search-component">
              <b-row
                class="desktop-screen"
              >
                <b-col
                  sm="10"
                  md="10"
                  lg="auto"
                  xl="auto"
                  class="search-width"
                >
                  <b-input-group
                    class="vt-search-bar float-component component-inside-1"
                    :class="{'disabled': differentLocation }"
                    size="sm"
                  >
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <fa-icon :icon="['fal', 'barcode-alt']" />
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <vt-input
                      :placeholder="`${ $t('archive.modal.enterLocation') }...`"
                      :disabled="differentLocation"
                      size="sm"
                    />
                    <b-input-group-append>
                      <div class="search-button-wrapper d-flex align-items-center">
                        <b-button
                          v-if="!differentLocation"
                          class="btn__icon btn__icon--primary  alt-btn px-2 py-0"
                        >
                          <i
                            class="far fa-times"
                            aria-hidden="true"
                          />
                        </b-button>
                      </div>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col>
            <div class="switch-btn mt-4 d-flex align-items-center">
              <span class="primary-dark-color mr-2">{{ $t('archive.modal.differentLocations') }}</span>
              <input
                id="toggleDifferentLocation"
                v-model="differentLocation"
                type="checkbox"
                class="offscreen"
                aria-hidden="true"
              >
              <label
                for="toggleDifferentLocation"
                class="switch mb-0"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="list px-2 mt-2">
              <div
                v-if="!elements.length"
                class="archive-empty-space"
              >
                <div class="main">
                  <div class="icon">
                    <archive />
                  </div>
                  <span class="text">{{ $t('archive.modal.emptyTitle') }}</span>
                </div>
                <div
                  class="empty-row"
                  style="opacity: .2"
                />
                <div
                  class="empty-row"
                  style="opacity: .15"
                />
                <div
                  class="empty-row"
                  style="opacity: .1"
                />
                <div
                  class="empty-row"
                  style="opacity: .05"
                />
              </div>
              <template v-else>
                <div class="header-row">
                  <b-row class="form-label px-2">
                    <b-col><label>{{ $tc('archive.modal.element', 1) }}</label></b-col>
                    <b-col class="col-8">
                      <label>{{ $t('archive.grid.archiveLocation') }}</label>
                    </b-col>
                  </b-row>
                </div>
                <div
                  v-testing="'elements-table'"
                >
                  <div
                    v-for="(element, index) in elements"
                    :key="index"
                    v-testing="'element-row'"
                    class="element-row bottom-bordered"
                  >
                    <b-row class="form-label px-2">
                      <b-col
                        v-testing="'element-label'"
                        class="col-4 d-flex align-items-center"
                      >
                        <div class="d-flex primary-dark-color font-weight--medium font-size--regular-2">
                          <span>{{ element.label }}</span>
                        </div>
                      </b-col>
                      <b-col class="col-4 search-width d-flex align-items-center">
                        <!-- TODO Front: Add if and else for location multiple or single, see UX document for details -->
                        <b-form-group
                          class="w-100 mb-0"
                          :state="!errors.has(element.label)"
                          :invalid-feedback="errors.first(element.label)"
                        >
                          <b-input-group
                            size="sm"
                            class="vt-search-bar float-component component-inside-1"
                          >
                            <b-input-group-prepend>
                              <b-input-group-text>
                                <fa-icon :icon="['fal', 'barcode-alt']" />
                              </b-input-group-text>
                            </b-input-group-prepend>
                            <vt-input
                              v-model="element.locationLabel"
                              v-testing="'barcode'"
                              v-validate="getLocationLabelValidationRules"
                              class="form-control-sm"
                              :data-vv-name="element.label"
                              :data-vv-as="$t('archive.grid.archiveLocation')"
                              :class="{'is-invalid': errors.has($t('archive.grid.archiveLocation')) }"
                            />
                          </b-input-group>
                        </b-form-group>
                        <div v-if="false">
                          -
                        </div>
                      </b-col>
                      <b-col class="d-flex align-items-center justify-content-end">
                        <button
                          v-testing="'delete-element'"
                          v-tooltip="$t('archive.modal.deleteElement')"
                          type="button"
                          class="btn btn__icon btn__icon--primary p-0 btn-secondary my-0"
                          @click="elements.splice(index, 1)"
                        >
                          <i
                            class="far fa-times mr-2"
                            aria-hidden="true"
                          />
                        </button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </template>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col class="d-flex justify-content-between">
          <b-button
            v-if="wizardModeEnabled"
            qa="archive-archive-back"
            class="btn__link px-3"
            @click="backButton"
          >
            <i
              class="far fa-arrow-left mr-2"
              aria-hidden="true"
            />{{ $t('archive.modal.back') }}
          </b-button>
          <b-button
            v-else
            v-testing="'cancel'"
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
          <b-button
            qa="archive-archive-button"
            size="sm"
            class="btn--primary"
            :disabled="!canArchive"
            @click="archiveElements"
          >
            <i
              class="far fa-inbox-in mr-2"
              aria-hidden="true"
            />
            {{ $t('archive.modal.archiving') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            v-testing="'cancel'"
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            qa="archive-add-button"
            size="sm"
            class="btn--primary"
            @click="hide"
          >
            <i
              class="far fa-inbox-in mr-2"
              aria-hidden="true"
            />
            {{ $t('archive.modal.archiving') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import SearcherModule from '@/components/SearcherModule'
import Archive from '@/assets/images/svg/Archive'
import ArchiveLocationSidepanel from '@/modules/archiveModule/views/components/ArchiveLocationSidepanel'
import { COREENTITY_VALUES } from '@/api/resources/incident/incidentServices'
import archiveService from '@/modules/archiveModule/services/archiveService'
import { SUBPORTION_TYPES } from '@/api/resources/subportionTypes'
import { PORTION_TYPES } from '@/api/resources/portionTypeService'
import { PortionOperation } from '@/api/operations/models/portion-operation'
import { SampleOperation } from '@/api/operations/models/sample-operation'
import { SubportionOperation } from '@/api/operations/models/subportion-operation'
import { ArchiveHelper } from '@/modules/archiveModule/services/archiveHelper'

export default {
    name: 'ArchiveAddModal',
    components: {
        SearcherModule,
        Archive,
        ArchiveLocationSidepanel
    },
    props: {
        laboratoryId: { type: Number, required: true },
        wizardModeEnabled: { type: Boolean, default: false },
        entityType: { type: Object,
            required: false,
            default: () => {
                return COREENTITY_VALUES.SAMPLE
            }
        },
        entitySubtype: {
            type: String,
            required: false,
            validator: value => [
                PORTION_TYPES.PARAFFIN_BLOCK.key,
                PORTION_TYPES.FROZEN_BLOCK.key,
                SUBPORTION_TYPES.SLIDE.key
            ].includes(value)
        }
    },
    data() {
        return {
            COREENTITY_VALUES: COREENTITY_VALUES,
            wizardStart: true,
            pendingToArchive: true,
            sidePanel: false,
            elements: [],
            internalEntityType: {},
            internalEntitySubtype: null,
            differentLocation: false
        }
    },
    computed: {
        showWizard() {
            return this.wizardModeEnabled && this.wizardStart
        },
        title() {
            if (this.internalEntityType.code === COREENTITY_VALUES.SAMPLE.code) {
                return 'archive.modal.archiveSamples'
            } else if (this.internalEntitySubtype === PORTION_TYPES.PARAFFIN_BLOCK) {
                return 'archive.modal.archiveParaffinBlocks'
            } else if (this.internalEntitySubtype === PORTION_TYPES.FROZEN_BLOCK) {
                return 'archive.modal.archiveFrozenBlocks'
            } else if (this.internalEntitySubtype === SUBPORTION_TYPES.SLIDE) {
                return 'archive.modal.archiveSlides'
            }
            return ''
        },
        elementIcon() {
            if (this.internalEntityType.code === COREENTITY_VALUES.SAMPLE.code) {
                return 'far fa-prescription-bottle'
            } else if (this.internalEntitySubtype === PORTION_TYPES.PARAFFIN_BLOCK) {
                return 'icon-block'
            } else if (this.internalEntitySubtype === PORTION_TYPES.FROZEN_BLOCK) {
                return 'icon-frozen-block'
            } else if (this.internalEntitySubtype === SUBPORTION_TYPES.SLIDE) {
                return 'icon-porta'
            }
            return ''
        },
        searcherValidationErrorMessage() {
            if (this.internalEntityType.code === COREENTITY_VALUES.SAMPLE.code) {
                return this.$t('archive.error.validSampleLabel')
            } else if (this.internalEntitySubtype === PORTION_TYPES.PARAFFIN_BLOCK) {
                return this.$t('archive.error.validParaffinBlockLabel')
            } else if (this.internalEntitySubtype === PORTION_TYPES.FROZEN_BLOCK) {
                return this.$t('archive.error.validFrozenBlockLabel')
            } else if (this.internalEntitySubtype === SUBPORTION_TYPES.SLIDE) {
                return this.$t('archive.error.validSlideLabel')
            }
            return this.$t('archive.error.validIdentifier')
        },
        getLocationLabelValidationRules() {
            return ArchiveHelper.getLocationLabelValidationRules(this.internalEntityType, this.internalEntitySubtype)
        },
        canArchive() {
            return !!this.elements.length
        }
    },
    watch: {
        entityType(newValue) {
            if (newValue) {
                this.internalEntityType = newValue
            }
        },
        entitySubtype(newValue) {
            this.internalEntitySubtype = this._mapStringToEntitySubtypeObject(newValue)
        }
    },
    methods: {
        _mapStringToEntitySubtypeObject(subtypeString) {
            switch (subtypeString) {
            case PORTION_TYPES.PARAFFIN_BLOCK.key:
                return PORTION_TYPES.PARAFFIN_BLOCK
            case PORTION_TYPES.FROZEN_BLOCK.key:
                return PORTION_TYPES.FROZEN_BLOCK
            case SUBPORTION_TYPES.SLIDE.key:
                return SUBPORTION_TYPES.SLIDE
            default:
                return null
            }
        },
        show(elements) {
            if (!elements) {
                this.elements = []
            } else {
                this.elements = elements.map(this.mapEntityToArchiveRequest)
            }
            this.internalEntityType = this.entityType
            this.internalEntitySubtype = this._mapStringToEntitySubtypeObject(this.entitySubtype)
            this.$refs.archiveAddModal.show()
        },
        mapEntityToArchiveRequest(entity) {
            const archiveRequest = archiveService.getEntityHierarchicalIds(entity)
            return {
                idHierarchy: archiveRequest,
                id: entity.id,
                label: entity.label,
                locationLabel: ''
            }
        },
        async archiveElements() {
            const valid = await this.$validator.validateAll()
            if (!valid) {
                return
            }
            this.updateLoading(true)
            const [err, response] = await this.toCall(archiveService.archiveBatch(this.laboratoryId, this.internalEntityType, this.elements))
            this.updateLoading(false)
            this.$emit('archived')
            if (err) {
                this.showErrorModalGlobalFromErrorResponse(err)
            } else if (response && response.length) {
                let errorMessage = ''
                const elementsWithError = []
                response.forEach(elementWithError => {
                    const elementIndex = this.elements.findIndex(element => element.id === elementWithError.id)
                    errorMessage = errorMessage + `<p>${this.elements[elementIndex].label}: ${elementWithError.errorMessage}</p>`
                    elementsWithError.push(this.elements[elementIndex])
                })
                this.elements = elementsWithError
                this.showErrorModalGlobal(this.$t('archive.error.errorArchiving') + `: ${errorMessage}`)
            } else {
                this.showToastSuccessGlobal(this.$t('archive.toastMessages.selectionArchived'))
                this.hide()
            }
        },

        _getEntityNotFoundErrorMessage(entityType) {
            switch (entityType) {
            case COREENTITY_VALUES.SAMPLE:
                return this.$tc('component.searcher.error.noSample')
            case COREENTITY_VALUES.PORTION:
                return this.$tc('component.searcher.error.noPortion')
            case COREENTITY_VALUES.SUBPORTION:
                return this.$tc('component.searcher.error.noSubportion')
            default:
                return this.$tc('archive.error.validIdentifier')
            }
        },
        _getEntityLabId(entity, entityType) {
            switch (entityType) {
            case COREENTITY_VALUES.SUBPORTION:
                return entity?.portion?.sample.caseStudy.laboratory.labId
            case COREENTITY_VALUES.PORTION:
                return entity?.sample?.caseStudy.laboratory.labId
            case COREENTITY_VALUES.SAMPLE:
                return entity?.caseStudy?.laboratory.labId
            default:
                return null
            }
        },
        async onEntitySearch(searchInformation) {
            const response =
                await this.$_toCallUnique(
                    archiveService.searchEntityByLabel(
                        this.laboratoryId,
                        searchInformation.search,
                        this.internalEntityType),
                    error => this.$_showErrorModalFromErrorResponse(
                        error,
                        error.response.data.code === this.$apiExceptions.ENTITY_NOT_FOUND
                            ? this._getEntityNotFoundErrorMessage(this.internalEntityType)
                            : undefined))

            if (response?.length) {
                let entitySelected = response[0]
                if (response.length > 1) {
                    const foundEntities =
                        response.map(entity => ({
                            entityType,
                            entityValue: entity.foundEntity,
                            laboratoryId: this._getEntityLabId(entity.foundEntity, entityType)
                        }))
                    const entityValueSelected =
                        await this.$_showMultiEntitySelection(searchInformation.search, foundEntities)

                    entitySelected = response.find(entity => entity.id === entityValueSelected.id)
                }
                if (
                    (this.internalEntityType === COREENTITY_VALUES.PORTION &&
                        this.internalEntitySubtype.key !== entitySelected?.foundEntity?.portionType) ||
                    (this.internalEntityType === COREENTITY_VALUES.SUBPORTION &&
                        this.internalEntitySubtype.key !== entitySelected?.foundEntity?.subportionType)
                ) {
                    this.$_showErrorModal(this.searcherValidationErrorMessage)
                } else if (this.elements.find(element => element?.id === entitySelected?.foundEntity?.id)) {
                    this.$_showErrorModal(this.$tc('component.searcher.error.elementAlreadyAdded'))
                } else if (!this.canArchiveElement(entitySelected?.executableOperations)) {
                    this.$_showErrorModal(this._getEntityNotFoundErrorMessage(this.internalEntityType))
                } else {
                    this.elements.push(this.mapEntityToArchiveRequest(entitySelected?.foundEntity))
                }
            }
        },

        canArchiveElement(operations) {
            let archiveOperation
            if (this.internalEntityType === COREENTITY_VALUES.SAMPLE) {
                archiveOperation = SampleOperation.ARCHIVE
            } else if (this.internalEntityType === COREENTITY_VALUES.PORTION) {
                archiveOperation = PortionOperation.ARCHIVE
            } else if (this.internalEntityType === COREENTITY_VALUES.SUBPORTION) {
                archiveOperation = SubportionOperation.ARCHIVE
            } else {
                return false
            }
            return operations?.includes(archiveOperation)
        },
        hide() {
            this.$refs.archiveAddModal.hide()
        },
        onHide() {
            this.elements = []
            this.$refs.searcherModule?.clearSearch()
            this.wizardStart = true
        },
        archiveSample() {
            this.wizardStart = false
            this.internalEntityType = COREENTITY_VALUES.SAMPLE
            this.internalEntitySubtype = null
        },
        archiveParaffinBlock() {
            this.wizardStart = false
            this.internalEntityType = COREENTITY_VALUES.PORTION
            this.internalEntitySubtype = PORTION_TYPES.PARAFFIN_BLOCK
        },
        archiveFrozenBlock() {
            this.wizardStart = false
            this.internalEntityType = COREENTITY_VALUES.PORTION
            this.internalEntitySubtype = PORTION_TYPES.FROZEN_BLOCK
        },
        archiveSlide() {
            this.wizardStart = false
            this.internalEntityType = COREENTITY_VALUES.SUBPORTION
            this.internalEntitySubtype = SUBPORTION_TYPES.SLIDE
        },
        backButton() {
            this.elements = []
            this.$refs.searcherModule.clearSearch()
            this.wizardStart = true
        }
    }
}
</script>

<style lang="scss">
    .add-modal .wizard-button {
        background: vt-color(primary);
        color: vt-color(white-light);
        border-radius: 3px;
        cursor: pointer;
        transition: .3s;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .add-modal .wizard-button:hover {
        background: vt-color(alt-primary);
    }
    .add-modal .wizard-button + p {
        margin-top: 10px;
        transition: .3s;
    }
    .add-modal .home {
        font-size: font-size-type(font-size-big-3);
    }
    .add-modal .wizard-button.home {
        height: 70px;
        width: 80px;
        font-size: 28px;
    }
    .add-modal .wizard-button.column {
        height: 40px;
        width: 45px;
        font-size: 18px;
    }
    .add-modal .barcode-input .input-group {
        border: 1px solid #ced4da;
        border-radius: 5px;
        height: 32px;
        padding-top: 1px;
        background: vt-color(white-light);
        width: 300px;
    }
    .add-modal .input-group-prepend .input-group-text {
        border-radius: 14px;
        color: vt-color(search-bar-text);
        border: none;
        font-size: 13px;
        padding: 0.6rem;
        background: transparent;
    }
    .add-modal input {
        width: 150px;
        border: none;
        color: vt-color(search-bar-text);
        font-size:1.1rem;
        padding-top:0.4rem;
        background: vt-color(white-light);
    }
    .add-modal .search-width {
        min-width: 280px !important;
    }
    .add-modal .archive-location-sidepanel {
        background: #FFF;
        width: 300px;
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        z-index: 4;
        box-shadow: -5px 0 5px -5px #b2b2b2;
        border: 1px solid vt-color(grid-general-border);
    }
    .add-modal .archive-location-sidepanel .title {
        color: vt-color(primary);
    }
    .add-modal .column-link {
        color: vt-color(primary) !important;
        cursor: pointer;
    }
    .add-modal .column-link:hover {
        color: vt-color(alt-primary) !important;
    }
    .add-modal .search-component {
        height: 30px;
    }
    .add-modal .vt-search-bar.disabled {
        background: #e9ecef;
        opacity: .5;
    }
    .archive-empty-space .main {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 30px 0;
    }
    .archive-wizard {
        min-height: 550px;
    }
    .archive-empty-space .icon,
    .archive-wizard .icon {
        width: 160px;
        opacity: .5;
    }
    .archive-empty-space .text {
        font-size: font-size(big);
        margin-top: 20px;
    }
    .making-zone .text {
        font-size: font-size(very-small);
    }
    .archive-empty-space .empty-row {
        height: 30px;
        margin: 5px 40px;
        background: vt-color(base-text);
        border-radius: 5px;
    }
    .add-modal .add-label {
        font-size: font-size(small);
        color: vt-color(dark-text);
    }
    .add-modal .modal-body {
        border-radius: .2rem;
    }
    .add-modal .making-zone .title {
        color: vt-color(primary);
        font-size: font-size(very-normal);
    }
    .add-modal .nav-link div {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .add-modal .nav-link {
        padding: 6px;
    }
    .add-modal .arrow {
        display: none;
    }
    .add-modal .list {
        min-height: 400px;
        max-height: 650px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .add-modal .list.large-list {
        height: 300px;
    }
    .add-modal .header-row {
        position: sticky;
        top: 0;
        z-index: 1;
    }
    .add-modal .element-row {
        border-bottom: 1px solid vt-color(grid-general-border);
        padding: 7px 0;
    }
    .add-modal .element-row:hover {
        background: vt-color(light-primary);
    }
    .remove-pop {
        padding: 0 !important;
    }
    .remove-pop ul {
        padding: 0;
        margin: 5px 0;
    }
    .remove-pop ul li {
        list-style: none;
        padding: 2px 20px;
        font-size: 12px;
        cursor: pointer;
    }
    .remove-pop ul li:hover {
        background: vt-color(light-primary);
    }
    .remove-pop .pop-header {
        background: vt-color(base-text, .9);
        padding: 8px 12px;
        font-weight: 700;
    }
    .context-header {
        background: vt-color(base-text, .9);
        padding: 6px 20px;
        font-weight: 700;
        margin-bottom: 5px;
    }
    .add-modal .ctx-menu {
        padding-top: 0;
    }
    .add-modal .shipping-box {
        margin: 10px 6px;
        border: 1px solid vt-color(base-text, .5);
        border-radius: 4px;
        box-shadow: 0 1px 1px 0 rgba(141, 141, 143, 0.3);
        border-left: 3px solid vt-color(primary);
    }
    .shipping-box .title {
        color: vt-color(primary);
    }

    @media (max-width: 1300px) {
        .add-modal .list {
            height: calc(100vh - 430px);
        }
    }

    @media only screen and (max-width: 1366px) and (min-width: 1360px) {
        .add-modal .modal-body {
            border-radius: .2rem;
            height: calc(100vh - 100px);
        }
        .add-modal .list {
            height: 440px;
        }
    }
</style>
